import React, { cloneElement, useEffect, useState } from "react";
import StickyBox from "react-sticky-box";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProjectDetail } from "api/project.api";
import { setSelectedProjectData } from "store/slices/projectSlice";
import { RootState } from "store/store";
import { error } from "console";
import { message } from "antd";
import ProjectScreeningSavedSearchesHeader from "./ProjectScreeningSavedSearchesHeader";
import ProjectScreeningSavedSearchesSecondHeader from "./ProjectScreeningSavedSearchesSecondHeader";

interface LayoutProps {
  children: React.ReactElement<{ tabKey: string; searchQuery?: string }>; // Add searchQuery as optional
}

const ProjectScreeningHeaderLayouts: React.FC<LayoutProps> = ({ children }) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const numberId = Number(id);
  const [state, setState] = useState<string>('');
  const selectedProject = useSelector((state: RootState) => state.projectSlice.update_project);
  const triggerProjectDetailChanges = useSelector((state: any) => state.talentPool.triggerProjectDetailRefresh);
  const [searchQuery, setSearchQuery] = useState<string>("");

  const getProjectDetails = async (id: number) => {
    if (numberId != null) {
      try {
        const response = await getProjectDetail(id);
        if (response) {
          dispatch(setSelectedProjectData(response));
      }
      } catch(error){
        console.log("Error: ", error);
        message.error("Somthing went wrong, Project Not Found!");
      }
    }
  };

  useEffect(() => {
    getProjectDetails(numberId);
  }, [numberId, state, selectedProject, triggerProjectDetailChanges]);

  const [previousIndex, setPreviousIndex] = useState<number[]>([]);
  const [currentIndex, setCurrentIndex] = useState<number>(1);
  const [tabKey, setTabKey] = useState("1");

   // Function to add (push) a tab number to the history
   const addTab = (tabNumber: number) => {
    setPreviousIndex((prev) => [...prev, tabNumber]);
  };

  // Function to remove (pop) the last tab number from the history
  const popTab = () => {
    setPreviousIndex((prev) => prev.slice(0, -1));
  };

  const getLastTab = () => {
    return previousIndex.length > 0 ? previousIndex[previousIndex.length - 1] : null;
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  return (
    <div className="w-reduce-sidebar ml-auto bg-utility-Grayblue">
      <StickyBox offsetTop={73} className="z-[1]">
        <ProjectScreeningSavedSearchesHeader selectedPool={numberId} popTab={popTab} getLastTab={getLastTab} currentIndex={currentIndex} setCurrentIndex={setCurrentIndex} setState={setState}/>
        <ProjectScreeningSavedSearchesSecondHeader selectedPool={numberId} addTab={addTab} currentIndex={currentIndex} setCurrentIndex={setCurrentIndex} tabKey={tabKey} setTabKey={setTabKey} searchQuery={searchQuery} setSearchQuery={setSearchQuery} handleSearchChange={handleSearchChange} />
      </StickyBox>
      {React.isValidElement(children) &&
        cloneElement(children, { tabKey, searchQuery })} {/* Pass setTabKey to children */}
    </div>
  );
};

export default ProjectScreeningHeaderLayouts;
